import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import moment from "moment";
import { InputText } from 'primereact/inputtext';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { FaTrash } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';
import { IoArrowBackSharp } from "react-icons/io5";
import { Api } from '../../services/api';
import { Galleria } from 'primereact/galleria'

const AdminHelp =  () => {
    const [imageList, setImagesList] = useState([  ]);
    const navigate = useNavigate();
    const toast = useRef(null);
   
    const [leadsId, setLeadsId] = useState(0);
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [showConfirmationDialogIsCall, setShowConfirmationDialogIsCall] = useState(false);
    const [errorTitle, setErrorTitle] = useState('');
    const [dateChangeOrNot, setDateChangeOrNot] = useState(false);
    const { editId } = useParams();
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [notes, setNotes] = useState([]);
    const [isFormSubmit, setIsFormSubmit] = useState(false);

    const [assignedList, setAssignedList] = useState([]);
    /***Galleria start  */

 
    const [activeIndex, setActiveIndex] = useState(0);
    const galleria = useRef(null);
    const itemTemplate = (item) => {
        console.log("----fffff----------->>");
        return <img src={Api.IMAGE_BASE_URL+item} alt=''  style={{ width: '100%', display: 'block' }} />;
    }

    const thumbnailTemplate = (item) => {
        console.log("----fffff----------->>");
        return <img src={Api.IMAGE_BASE_URL+item} alt='' style={{ display: 'block' }} />;
    }
    /***Galleria end */

    const [statusList, setStatusList] = useState([
        { name: 'Pending', id: 'pending' },
        { name: 'In Progress', id: 'open' },
        { name: 'Completed', id: 'close' }
    ]);

    const [priorityList, setPriorityList] = useState([
        { name: 'Low', id: 'low' },
        { name: 'Medium', id: 'medium' },
        { name: 'High', id: 'high' }
    ]);


    const formik = useFormik({
        initialValues: {
            issue: '',
            priority: priorityList[0]?.id || '', // Default to 'low' if available
            status: statusList[0]?.id || '',
            assigne_list: '',
            opened: '',
            fixed: '',
            description: '',
        },
        validate: (data) => {
            let errors = {};
            return errors;
        },

        onSubmit: (data) => {

        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    useEffect(() => {
        getLeadData();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);
    // }, [editId, leadsId]);

    // useEffect(() => {
    //     console.log('Updated imageList: ', imageList); // Log whenever imageList changes
    // }, [imageList]);

    const getLeadData = async () => {
        var leadId = 0;
        if (editId !== undefined) {
            leadId = editId;
        }
        if (leadsId != 0) {
            leadId = leadsId;
        }

        if (leadId == 0) {
            return true;
        }
    
        const token = localStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'help/get/' + leadId, { headers })
            .then((response) => {

                console.log("response --->", response.data.result)
                const leadData = response.data.result;
                const notesData = response.data.result.notes;
                
                setAssignedList(response.data.result.assigne_list)
                
                if (leadData) {
                    console.log("Lead Data:", leadData); // Log leadData
                    console.log("Lead Data Images:", leadData.image); // Log leadData.image
let t = []
                    for (let index = 0; index < leadData.image.length; index++) {
                        let element = leadData.image[index];
                        t.push(customBase64Uploader(element))
                        
                    }
                    setImagesList(leadData.image || []); // Set to empty array if undefined
                    editCopyModal(leadData, 'Edit');
    
                    // setImagesList(leadData.image);
                    // setImagesList(leadData.image || []);
                    console.log('rowData.image------&&&------>', imageList);
                   // setImages2(leadData.image);
                    // editCopyModal(leadData, 'Edit');
                }
                if (notesData) {
                    setNotes(notesData);
                    console.log('notesData-------->', notesData)

                    // const formattedNotes = notesData.map(note => ({
                    //     id: note._id,
                    //     createdAt: moment(note.created_at).format('YYYY-MM-DD HH:mm:ss'), // Format date as needed
                    //     createdBy: `${note.created_by.first_name} ${note.created_by.last_name}`,
                    //     notes: note.notes || 'No content', // Use 'No content' if notes are null
                    // }));
                    // setNotes(formattedNotes);
                }

            })
            .catch((error) => {
                setIsFormSubmit(true);
                console.error('Error fetching projects:', error);
            });
    }


    const editCopyModal = (rowData, colType) => {
      
        setLeadsId(rowData._id);
        formik.setValues({
            issue: rowData.issue,
            priority: rowData.priority,
            status: rowData.status,
            // assigne_list: rowData.assigne_list,
            assigned: rowData.assigned,
          //  opened: rowData.opened,
            //fixed: rowData.fixed,
            description: rowData.description,

        });
        setIsFormSubmit(true);
    };

    const [savedFields, setSavedFields] = useState({});
    const [isSavingNotes, setIsSavingNotes] = useState(false);

    //! -------------------
    const onInputChange = (fieldName, value, rowData) => {

        formik.setFieldValue(fieldName, value);
       
    };

    const saveData = () => {
        // Here you can handle the logic for saving the data

        const dataToSave = {

            ...formik.values,
            userId: localStorage.getItem('user_id'), // Add any additional data you need
        };

        const token = localStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };

        axios.post(Api.API_BASE_URL + 'help/update/' + editId, dataToSave, { headers })
            .then(response => {
                // Handle success
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });
            })
            .catch(error => {
                // Handle error
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save data' });
            });
    };

    const saveNote = () => {
        const noteToSave = {
            notes: formik.values.notes,
            userId: localStorage.getItem('user_id'), 
            id: leadsId, // Assuming you want to associate the note with the current lead
        };
    
        const token = localStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
    
        axios.post(Api.API_BASE_URL + 'help/save-notes', noteToSave, { headers })
            .then(response => {
                // Handle success
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Note saved successfully' });
                var k = {
                    id: response.data.id,
                    notes: formik.values.notes,
                    name: localStorage.getItem('name'),
                    roles: localStorage.getItem('role_name'),
                    created_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                    image: localStorage.getItem('image') ?? null
                }
                console.log(k)

                var arr = [k, ...notes]
                setNotes(arr);
                // Optionally, you can update the notes state to include the new note
           
                formik.setFieldValue('notes', ''); // Clear the notes input
            })
            .catch(error => {
                // Handle error
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save note' });
            })
            .finally(() => {
                setIsSavingNotes(false); // Reset the saving state
            });
    };



    const renderDropdown = (label, fieldName, options, optionLabel) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <Message severity="success" text="Saved"
                    style={{
                        position: 'absolute',
                        top: 0,
                        // right: 0,
                        zIndex: 1,
                    }}
                />
            )}
            <Dropdown
                optionValue='id'
                id={fieldName}
                name={fieldName}
                placeholder={`select ${label.toLowerCase()}`}
                options={options}
                optionLabel={optionLabel}
              
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.value);
                }}
                className={classNames('p-2', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    const renderInput = (label, fieldName, type = "text") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>

            {savedFields[fieldName] && (
                <Message severity="success" text="Saved "
                    style={{
                        position: 'absolute',
                        top: 0,
                        // right: 0,
                        zIndex: 1,
                    }}
                />
            )}
            <InputText
                id={fieldName}
                name={fieldName}
                type={type}
                autoComplete="off"
                value={formik.values[fieldName]}
                onChange={(e) => onInputChange(fieldName, e.target.value)}
                className={classNames('p-2 ', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );



    const renderDateInput = (label, fieldName) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <Message severity="success" text=" Saved"
                    style={{
                        position: 'absolute',
                        top: 0,
                        // right: 0,
                        zIndex: 1,
                    }}
                />
            )}
            <InputText
                id={fieldName}
                name={fieldName}
                type='date'
                autoComplete="off"
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.target.value);
                    if (fieldName === 'fsa_date') { setDateChangeOrNot(true); }
                }}
                className={classNames('p-2', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    const renderHtmlEditor = (label, fieldName) => (
        <div className="col-12 pt-3" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <Message severity="success" text="Saved"
                    style={{
                        position: 'absolute',
                        top: 0,
                        // right: 0,
                        zIndex: 1,
                    }}
                />
            )}
            <ReactQuill
                id={fieldName}
                name={fieldName}
                value={formik.values[fieldName]}
                onChange={(value) => {
                    if (fieldName === 'notes') {
                        formik.setFieldValue('notes', value);
                    } else {

                        onInputChange(fieldName, value)
                    }
                }}
                style={{ minHeight: '7.5em' }}
                className="px-0"
            />
        </div>
    );

    const renderHtmlEditorNotes = (label, fieldName) => (
        <div className="pt-3" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            <ReactQuill
                id={fieldName}
                name={fieldName}

                value={formik.values[fieldName]}
                onChange={(value) => {
                    if (fieldName === 'notes') {
                        formik.setFieldValue('notes', value);
                    } else {
                        onInputChange(fieldName, value);
                    }
                }}
                className="px-0 "
            />
        </div>
    );


    const footerContentConfirmation = (
        <div className='m-2 ' >
            <Button label="Cancel" title='Cancel' severity="secondary" className='p-1 m-1' onClick={() => setShowConfirmationDialog(false)} />
            <Button label="No" title='No' severity="danger" className='p-1 px-4 m-1 mx-2' onClick={() => {
                setShowConfirmationDialog(false);
                setShowConfirmationDialogIsCall(true);
                setErrorTitle('');
                formik.setFieldValue('projectCreated', 'project not create');
                formik.handleSubmit();
            }} />

            <Button label="Yes" title='Yes' onClick={() => {
                setShowConfirmationDialog(false);
                setShowConfirmationDialogIsCall(true);
                setErrorTitle('');
                formik.setFieldValue('projectCreated', 'project create');
                formik.handleSubmit();
            }} severity="success" autoFocus className='p-1 px-4 m-1 mx-2' />
        </div>
    );

    const handleDeleteNote = (noteId) => {
        console.log('noteId:', noteId);
        var _body = {
           
            id: noteId,
        };
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var url = Api.API_BASE_URL + 'help/delete-notes';

        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.error === '') {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Note deleted successfully' });
                    setNotes(notes.filter((note) => note.id !== noteId));
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete note' });
                }
            })
            .catch((error) => {
                console.error('Error deleting note:', error);
            });
    };


    // ---------------------
    const customBase64Uploader = async (imageURL) => {
        var re  =''
        try {
          // Fetch the image from the URL
          const response = await fetch(imageURL);
          const blob = await response.blob(); // Convert the image to a Blob
      
          // Create a FileReader to read the Blob as Data URL (Base64)
          const reader = new FileReader();
      
          reader.onloadend = function () {
            re = reader.result;
            // You can now use the base64data, for example, store it in formik or display it
            //formik.setFieldValue("image", base64data);
           // console.log("Base64 Image Data: ", base64data);
          };
      
          // Read the Blob as a Data URL (Base64)
          reader.readAsDataURL(blob);
        } catch (error) {
          console.error("Error converting image to Base64:", error);
        }
        return  re
      };
      
      // Example usage
    //   const imageURL = 'http://35.239.153.120:3001/upload/helpPage/1731672410780.png';
    //   customBase64Uploader(imageURL);
      
    // ---------------------


    return (
        <>
            <Toast ref={toast} />


            <Dialog header="Confirmation" headerClassName="centered-header" visible={showConfirmationDialog} style={{ width: '30vw' }} dismissableMask={true} onHide={() => setShowConfirmationDialog(false)} footer={footerContentConfirmation}>
                {/* Dialog content */}
                <div className=" m-2 item-center justify-center">
                    <span style={{ marginBottom: '1rem' }}>It will create a project in production schedule and playbook. Do you want to continue ?</span>
                </div>
            </Dialog>

            <button type='button' onClick={() => { navigate(-1);}} className='customSave-button m-2 flex'>
                <IoArrowBackSharp className='text-sm' />
                <span>Back</span>
            </button>

            {/* // -----------dialog Box------- */}
            <div className='card' style={{ margin: '5px 10px', height: '83vh', overflowY: 'scroll', border: '1px solid #A8A8A8' }}>
                <form onSubmit={formik.handleSubmit} className="flex">
                    <div className="flex-col m-2" style={{ minWidth: '40vw' }}>
                        <div className='flex '>
                            {/* //*---- First Column -------- */}
                            <div className='flex-col col-6 py-0'>
                                <h4 style={{ backgroundColor: '#F8EED7' }} className='text-center py-2 bg-[#CC9A36] title-font'>
                                    {/* Client Details */}
                                </h4>
                                {renderInput("Issue", "issue")}
                                {renderDropdown("Priority*", "priority", priorityList, "name")}
                                {renderDropdown("Status*", "status", statusList, "name")}
                                {renderDropdown("Assigne*", "assigned", assignedList, "name")}
                                {renderDateInput("Opened", "opened")}
                                {renderDateInput("Fixed", "fixed")}

                            </div>

                            {/* //*---- Second Column -------- */}
                            <div className='flex-col col-6 py-0'>
                                <h4 style={{ backgroundColor: '#F8EED7' }} className='text-center py-2 title-font' >
                                 
                                </h4>
                               
                               
                              
                                {/**  //* Galleria start      */}
                                <Galleria ref={galleria} value={imageList} numVisible={7}  style={{ maxWidth: '850px' }}
                                    activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                                    circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />
                                <div className="grid" style={{ maxWidth: '400px' }}>
                                    {
                                         imageList.map((image, index) => {
                                           
                                            let imgEl = <img src={Api.IMAGE_BASE_URL+image} alt='' style={{ cursor: 'pointer' ,width:"100px",height:"100px", paddingTop:"10px" }} onClick={
                                                () => { setActiveIndex(index); galleria.current.show() }
                                            } />
                                            if(index<12){
                                            return (
                                                <div className="col-4" key={index}>
                                                    {imgEl}
                                                </div>
                                            ) }else {
                                            return null}
                                        })
                                    }
                                </div>

                                {/** //! --------Galleria end------------ */}

                            </div>

                        </div>
                        <div className=''>
                            {renderHtmlEditor("Description", "description")}
                        </div>

                        <div className='w-full  justify-center' style={{ marginLeft: '50%' }}>
                            <Button
                                type="button"
                                onClick={saveData}
                                title='Save the Date'
                                style={{ cursor: 'pointer' }}
                                disabled={isSubmitting || isSavingNotes}
                                className="customSave-button mt-2 "
                            >

                                <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                    <span>Save</span>
                                </div>

                            </Button>

                        </div>
                    </div>

                    <div className='px-4 flex-col col-6' style={{ minWidth: '40vw', borderLeft: '1px solid #c4c1c1' }}>

                        <div className=''>
                            <h4 style={{ backgroundColor: '#F8EED7', borderTop: '1px solid #000' }} className='text-center py-2 title-font' >
                                Comments
                            </h4>
                            <div className='flex-col '>
                                <div className='flex-col col-12 ' >
                                    {renderHtmlEditorNotes("Comments", "notes")}
                                </div>

                                <div className='mt-2' style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Button
                                        type="button"
                                        onClick={(e) => {
                                            setIsSavingNotes(true);
                                            // onInputChange('notes', formik.values.notes);
                                            saveNote();
                                        }}
                                        title='Save the Date'
                                        style={{ cursor: 'pointer' }}
                                        disabled={isSubmitting || isSavingNotes}
                                        className="customSave-button mt-2"
                                    >
                                        {isSavingNotes ? (
                                            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                                <Spinner size={16} color="#fff" />
                                                <span>Saving...</span>
                                            </div>
                                        ) : (
                                            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                                <span>Save Comments</span>
                                            </div>
                                        )}
                                    </Button>
                                </div>
                            </div>

                            <div className='mt-4' >
                                {notes.map((note, index) => (
                                    <Card key={index} className="py-2 shadow-2xl mt-2 ml-2 leads-card">
                                        <div className='flex' style={{ alignItems: 'center', justifyContent: 'space-between' }}> 
                                            <div className='flex user-image' style={{ alignItems: 'center' }}>

                                                {note.image || note.image !=""   ?
                                                    <img src={`${note.image}`} alt="Image" className="rounded-full m-2" style={{ height: '50px', width: '40px' }} />
                                                    :
                                                    <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt="Image" className=" rounded-full m-2" style={{ height: '50px', width: '40px' }} />
                                                }

                                                <div className='p-2' style={{ minWidth: '150px' }}>
                                                    <h5 className="text-lg font-bold">{note.name}</h5>
                                                    <p className="text-gray-600 text-sm">{note.created_at}</p>
                                                </div>
                                                <div className='pl-4 px-2'>
                                                    <p dangerouslySetInnerHTML={{ __html: note.notes }} />
                                                </div>
                                            </div>
                                            <div>
                                                <FaTrash onClick={() => handleDeleteNote(note.id)} style={{ color: 'darkred', marginRight: '10px', cursor: "pointer" }} />
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </div>

                    </div>

                </form>
            </div>
        </>
    );
};

export default AdminHelp;

